import { useRemoteConfig } from '@funtech-int/yango-shared';

import { remoteConfigSchema, type BenefitType } from '../lib/remoteConfig';

export type { BenefitType };

export function useYangoOnboardingConfig() {
    const remoteConfig = useRemoteConfig(remoteConfigSchema);

    return remoteConfig.get('onboarding_config');
}
